var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hl-Select',{attrs:{"label":"Bygg","options":_vm.buildingOptions,"placeholder":"Velg bygg","placeholderValue":"__default__"},model:{value:(_vm.building),callback:function ($$v) {_vm.building=$$v},expression:"building"}})
}
var staticRenderFns = []

export { render, staticRenderFns }